import { _ as mr } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.filter-4e9c9996.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.from-fe752fa6.js";
import "./es.array.concat-d1c9b847.js";
import "./es.array.index-of-084b82ab.js";
import "./es.array.some-0c761b6d.js";
import { _ as pr } from "./export-cdcbfb2b.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.iterator-5de8a61e.js";
import { c as wr } from "./index-8b07dec9.js";
import br, { useRef as A, useEffect as L } from "react";
import "./es.object.keys-9d66766f.js";
import "@ucl/shared-component-foundations";
import { useClient as Fr } from "./useClient.js";
import { useEventListener as E } from "./useEventListener.js";
import "./web.set-timeout-72b6430f.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import { c as gr } from "./combineRefs-c9ad2c39.js";
import { useOnClickOutside as P } from "./useOnClickOutside.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { jsx as vr } from "react/jsx-runtime";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./iterate-13ada9e5.js";
import "./classof-21a3574e.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./array-method-is-strict-e5a3c878.js";
import "./web.dom-collections.for-each-3020ed11.js";
import "./isClient-2f5bedbd.js";
import "./getTarget-19e0f923.js";
import "./function-apply-4756dee6.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./es.array.every-3d11adb5.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
var Tr = pr;
Tr({ target: "Number", stat: !0 }, {
  isNaN: function(b) {
    return b !== b;
  }
});
var w = /* @__PURE__ */ function(o) {
  return o.TAB = "tab", o.ARROW = "arrow", o.ARROW_UP_DOWN = "arrow-up-down", o.ARROW_LEFT_RIGHT = "arrow-left-right", o.BOTH = "both", o;
}({}), Ar = ["open", "navigationType", "selector", "ignoredSelector", "disableAutoFocus", "disableEnforceFocus", "disableRestoreFocus", "disableFocusCycle", "allowHidden", "allowNegativeTabFocus", "allowTabDefaults", "disableScrollFocusInView", "getFocusableElements", "onFocusedOutside", "onClickedOutside", "onFocusNext", "onFocusPrevious", "children", "className", "style"], Er = function(b, O, n, y) {
  var f = Array.from(b.querySelectorAll(O || "a[href], button, textarea, input, select, [tabindex]")).filter(function(m) {
    return n || m.offsetParent !== null;
  }).filter(function(m) {
    return y || m.tabIndex >= 0;
  });
  return f;
}, Oe = /* @__PURE__ */ br.forwardRef(function(o, b) {
  var O = o.open, n = O === void 0 ? !1 : O, y = o.navigationType, f = y === void 0 ? w.TAB : y, m = o.selector, W = o.ignoredSelector, p = W === void 0 ? "[disabled]" : W, U = o.disableAutoFocus, x = U === void 0 ? !1 : U, B = o.disableEnforceFocus, D = B === void 0 ? !1 : B, j = o.disableRestoreFocus, S = j === void 0 ? !1 : j, K = o.disableFocusCycle, H = K === void 0 ? !1 : K, V = o.allowHidden, q = V === void 0 ? !1 : V, G = o.allowNegativeTabFocus, z = G === void 0 ? !1 : G, J = o.allowTabDefaults, F = J === void 0 ? !1 : J, M = o.disableScrollFocusInView, s = M === void 0 ? !1 : M, C = o.getFocusableElements, Q = o.onFocusedOutside, X = o.onClickedOutside, g = o.onFocusNext, v = o.onFocusPrevious, Y = o.children, er = o.className, or = o.style, tr = mr(o, Ar), l = A(null), i = A([]), I = A(null), _ = A(null), Z = A(null), T = A(0), a = Fr();
  L(function() {
    var t;
    if (!(S || !n))
      return Z.current = (t = a.document) == null ? void 0 : t.activeElement, function() {
        var r;
        (r = Z.current) == null || r.focus({
          preventScroll: s
        });
      };
  }, [a, S, s, n]), L(function() {
    if (!(!n || !l.current)) {
      var t = Er(l.current, m, q, z);
      i.current = t, C == null || C(t), I.current = t[0], _.current = t[t.length - 1];
    }
  }, [n, a, m, x, C, q, z, F, Y]), L(function() {
    var t, r, e;
    !n || x || !l.current || (!((t = a.document) != null && t.activeElement) || !l.current.contains((r = a.document) == null ? void 0 : r.activeElement)) && ((e = i.current[0]) == null || e.focus({
      preventScroll: s
    }));
  }, [a, x, s, n]);
  var nr = function(r) {
    if (!(!l.current || r.target === window || !l.current.contains(r.target))) {
      var e = i.current.indexOf(r.target);
      e = e === -1 ? i.current.findIndex(function(c) {
        return c.contains(r.target);
      }) : e, T.current = e === -1 ? 0 : e;
    }
  }, k = function(r) {
    if (!(!l.current || r.target === window || l.current.contains(r.target))) {
      if (D)
        return r.type === "pointerdown" || r.type === "click" ? X == null ? void 0 : X(r) : Q == null ? void 0 : Q(r);
      r.preventDefault(), r.stopPropagation();
      var e = i.current[T.current];
      s || e == null || e.blur(), e == null || e.focus({
        preventScroll: s
      });
    }
  }, R = function(r) {
    return !l.current || D && !l.current.contains(r.target) || p && r.target.matches(p) ? !1 : !Array.from(l.current.querySelectorAll(".FocusTrap.FocusTrap--open")).some(function(e) {
      return e.contains(r.target);
    });
  }, $ = function(r) {
    var e = i.current.indexOf(r.target);
    if (e === -1) {
      var c = i.current.findIndex(function(d) {
        return d.contains(r.target);
      });
      return c === -1 ? i.current.length - 1 : c;
    }
    return e;
  }, h = function(r, e) {
    var c, d;
    if (!(H && e === i.current.length - 1)) {
      var u = (e + 1) % i.current.length;
      if (u = Number.isNaN(u) ? 0 : u, p && p !== m && (c = i.current[u]) != null && c.matches(p))
        return h(r, u);
      (d = i.current[u]) == null || d.focus({
        preventScroll: s
      }), g == null || g(r, e, u);
    }
  }, N = function(r, e) {
    var c, d;
    if (!(H && e === 0)) {
      var u = (e - 1 + i.current.length) % i.current.length;
      if (u = Number.isNaN(u) ? 0 : u, p && p !== m && (c = i.current[u]) != null && c.matches(p))
        return N(r, u);
      (d = i.current[u]) == null || d.focus({
        preventScroll: s
      }), v == null || v(r, e, u);
    }
  }, ir = function(r) {
    if (!(r.code !== "Tab" || !R(r))) {
      r.preventDefault();
      var e = $(r);
      r.shiftKey ? N(r, e) : h(r, e);
    }
  }, ur = function(r) {
    if (!(r.code !== "Tab" || !R(r))) {
      var e = r.target === I.current, c = r.target === _.current;
      if (!H && c && !r.shiftKey) {
        var d;
        r.preventDefault(), (d = I.current) == null || d.focus({
          preventScroll: s
        }), g == null || g(r, i.current.length - 1, 0);
      } else if (!H && e && r.shiftKey) {
        var u;
        r.preventDefault(), (u = _.current) == null || u.focus({
          preventScroll: s
        }), v == null || v(r, 0, i.current.length - 1);
      } else
        r.shiftKey ? v == null || v(r, T.current, T.current - 1) : g == null || g(r, T.current, T.current + 1);
    }
  }, lr = function(r) {
    if (!(F && r.code === "Tab") && !(!["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight", "Tab"].includes(r.code) || !R(r)) && (r.preventDefault(), r.code !== "Tab")) {
      var e = $(r);
      ["ArrowDown", "ArrowRight"].includes(r.code) ? h(r, e) : N(r, e);
    }
  }, ar = function(r) {
    if (!(F && r.code === "Tab") && !(!["ArrowDown", "ArrowUp", "Tab"].includes(r.code) || !R(r)) && (r.preventDefault(), r.code !== "Tab")) {
      var e = $(r);
      r.code === "ArrowDown" ? h(r, e) : N(r, e);
    }
  }, cr = function(r) {
    if (!(F && r.code === "Tab") && !(!["ArrowLeft", "ArrowRight", "Tab"].includes(r.code) || !R(r)) && (r.preventDefault(), r.code !== "Tab")) {
      var e = $(r);
      r.code === "ArrowRight" ? h(r, e) : N(r, e);
    }
  };
  P(n && l, k, "click", !0), P(n && l, k, "pointerdown", !0), P(n && l, k, "focusin", !0), E("focusin", nr, n ? a.window : !1, !0);
  var rr = f === w.TAB || f === w.BOTH, sr = f === w.ARROW || f === w.BOTH, dr = f === w.ARROW_UP_DOWN, fr = f === w.ARROW_LEFT_RIGHT;
  return E("keydown", ir, n && !F && rr ? a.window : !1, !0), E("keydown", ur, n && F && rr ? a.window : !1, !0), E("keydown", lr, n && sr ? a.window : !1, !0), E("keydown", ar, n && dr ? a.window : !1, !0), E("keydown", cr, n && fr ? a.window : !1, !0), /* @__PURE__ */ vr("section", Object.assign({}, tr, {
    ref: gr(l, b),
    style: Object.assign({}, or, {
      display: "contents"
    }),
    className: wr(["FocusTrap", "FocusTrap--navigationType-" + f, {
      "FocusTrap--open": n,
      "FocusTrap--disableAutoFocus": x,
      "FocusTrap--disableEnforceFocus": D,
      "FocusTrap--disableRestoreFocus": S,
      "FocusTrap--disableScrollFocusInView": s
    }, er]),
    children: Y
  }));
});
export {
  Oe as FocusTrap,
  w as FocusTrapNavigationType
};
